import React from 'react';

import { StyleSheet, View } from '@react-pdf/renderer';

import { SWOTItem } from './SWOTItem';

export interface IItem {
  title: string;
  iconSrc: string;
  content: string[];
}

interface IProps {
  data: IItem[];
  isSecond: boolean;
}

export const SWOTRow: React.FC<IProps> = ({ data, isSecond }) => {
  return (
    <View
      style={[styles.rowWrapper, { marginTop: isSecond ? '14px' : '0px', marginBottom: isSecond ? '24px' : '0px' }]}
      wrap={false}
    >
      {data.map((item, index) => {
        const hasNoContent = (item.content.length === 1 && item.content[0] === '') || item.content.length === 0;

        return hasNoContent ? null : <SWOTItem key={index} data={item} isRight={index === data.length - 1} />;
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  rowWrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
});
